// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--nav-height);
  background: rgba(10, 14, 20, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border);
  z-index: 100;
}

.nav-inner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  font-family: var(--font-mono);
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
  text-decoration: none;
}

.nav-links {
  display: flex;
  list-style: none;
  gap: 1.75rem;
}

.nav-links a {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--text-muted);
  text-decoration: none;
  text-transform: lowercase;
  transition: color var(--transition);
}

.nav-links a:hover,
.nav-links a.active { color: var(--accent); }

.footer {
  border-top: 1px solid var(--border);
  padding: 2.5rem 0;
  text-align: center;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--text-muted);
}

.footer a { color: var(--text-muted); }
.footer a:hover { color: var(--accent); }

.cursor {
  display: inline-block;
  width: 8px;
  height: 1em;
  background: var(--accent);
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: blink 1s step-end infinite;
}

@media (max-width: 640px) {
  .nav-links { gap: 1rem; font-size: 0.75rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;sBACsB,oBAAoB,EAAE;;AAE5C;EACE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,YAAY,wBAAwB,EAAE;AACtC,kBAAkB,oBAAoB,EAAE;;AAExC;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa,SAAS,EAAE,kBAAkB,EAAE;AAC9C","sourcesContent":[".nav {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: var(--nav-height);\r\n  background: rgba(10, 14, 20, 0.85);\r\n  backdrop-filter: blur(12px);\r\n  border-bottom: 1px solid var(--border);\r\n  z-index: 100;\r\n}\r\n\r\n.nav-inner {\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.logo {\r\n  font-family: var(--font-mono);\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text);\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-links {\r\n  display: flex;\r\n  list-style: none;\r\n  gap: 1.75rem;\r\n}\r\n\r\n.nav-links a {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n  text-decoration: none;\r\n  text-transform: lowercase;\r\n  transition: color var(--transition);\r\n}\r\n\r\n.nav-links a:hover,\r\n.nav-links a.active { color: var(--accent); }\r\n\r\n.footer {\r\n  border-top: 1px solid var(--border);\r\n  padding: 2.5rem 0;\r\n  text-align: center;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.footer a { color: var(--text-muted); }\r\n.footer a:hover { color: var(--accent); }\r\n\r\n.cursor {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 1em;\r\n  background: var(--accent);\r\n  margin-left: 2px;\r\n  vertical-align: text-bottom;\r\n  animation: blink 1s step-end infinite;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .nav-links { gap: 1rem; font-size: 0.75rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
